import { Pagination } from '../Pagination/Pagination';
import { tablePaginationStyle } from './TablePagination.css';
import { useTableContext, useTableScrollTarget } from './TableRoot.context';

export type Props = {
  showPageSizeOptions?: boolean;
};

export const TablePagination = ({ showPageSizeOptions = false }: Props) => {
  const scrollTargetRef = useTableScrollTarget();
  const { getRowCount, setPagination, state } = useTableContext();

  return (
    <Pagination
      className={tablePaginationStyle}
      onChange={setPagination}
      pageIndex={state.pagination.pageIndex}
      pageSize={state.pagination.pageSize}
      scrollTargetRef={scrollTargetRef ?? undefined}
      showPageSizeOptions={showPageSizeOptions}
      totalResults={getRowCount()}
    />
  );
};
